import React from 'react';
import PropTypes from 'prop-types';

const Email = props => <span>{props.data.email}</span>;

Email.propTypes = {
	data: PropTypes.object.isRequired,
};

export default Email;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/email.js